import * as yup from 'yup';

export const restaurantSchema = yup.object({
  itemName: yup.string().required('Description is required'),
  itemImage: yup.string(),
  amount: yup.number().required('Amount is required').positive('Amount must be positive')
});
